import { createContext, useContext } from 'react';

export const AddressInfoListItemContext = createContext();

export const useAddressInfoListItemContext = () =>
  useContext(AddressInfoListItemContext);

export default AddressInfoListItemContext;
